export default "__VITE_ASSET__DXIM42WV__"